import { useCallback, useContext } from "react";
import { useMsal } from "@azure/msal-react";
import { getToken, useMsalAuth } from "../../authConfig";
import { useOrganization } from "../../contexts/OrganizationContext";
import { LoginContext } from "../../loginContext";

export function useBuilderIdentity() {
    const { instance } = useMsal();
    const { context, switching } = useOrganization();
    const { userInfo } = useContext(LoginContext);
    const resolveToken = useCallback(() => useMsalAuth ? getToken(instance) : Promise.resolve(undefined), [instance]);
    return { resolveToken, scope: `${userInfo.email}:${context?.currentOrganizationId ?? "personal"}`, switching };
}
